import { render, staticRenderFns } from "./EventRegional.view.vue?vue&type=template&id=a13f7f8a"
import script from "./EventRegional.view.vue?vue&type=script&lang=ts"
export * from "./EventRegional.view.vue?vue&type=script&lang=ts"
import style0 from "./EventRegional.view.vue?vue&type=style&index=0&id=a13f7f8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTab,VTabItem,VTabs,VTabsItems,VTextField})
